import type { ImportStepProps, ImportStepMap } from "./import-types";
import { clientEnvModule } from "@/modules/client-env";
import { observer } from "mobx-react-lite";
import { AppleNotesOneClickStepDesktop } from "./apple-notes-one-click-step-desktop";
import { AppleNotesOneClickStepWeb } from "./apple-notes-one-click-step-web";
import { OneClickImportStep } from "./one-click-import-step";

// Wrapper component that checks feature flag and renders appropriate flow
const AppleNotesOneClickStep: React.FC<ImportStepProps> = observer(props => {
  const isDesktop = clientEnvModule.isDesktop();

  if (isDesktop) {
    return <AppleNotesOneClickStepDesktop {...props} />;
  }

  return <AppleNotesOneClickStepWeb {...props} />;
});

export const AppleNotesStepsMap: ImportStepMap = {
  "apple-notes-1": {
    id: "apple-notes-1",
    render: props => <AppleNotesOneClickStep {...props} />,
  },
  "apple-notes-one-click": {
    id: "apple-notes-one-click",
    render: props => <OneClickImportStep {...props} />,
  },
};
